import { render, staticRenderFns } from "./TravelClaimStaging.vue?vue&type=template&id=56607748&"
import script from "./TravelClaimStaging.vue?vue&type=script&lang=js&"
export * from "./TravelClaimStaging.vue?vue&type=script&lang=js&"
import style0 from "./TravelClaimStaging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelClaimStaging.vue"
export default component.exports